import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAccount } from '../contexts/AccountContext';
import { firstAccessiblePath } from '../domain/access';

/**
 * Garde de l'écran `/admin`. Deux populations y entrent, pour deux choses
 * différentes :
 *
 * - `extranet-admin` : la gestion des membres **et** les invitations ;
 * - tout membre portant au moins un rôle : les invitations seules, et
 *   uniquement sur ses propres rôles et périmètres (cf. `AccessEditor`).
 *
 * C'est la seule route qui ne se garde pas sur une permission : inviter n'en a
 * pas, le droit vient de `/me.access`.
 */
export const RequireAdminArea = ({ children }: { children: ReactNode }) => {
  const { isAdmin, canInvite, permissions } = useAccount();
  if (!isAdmin && !canInvite) return <Navigate to={firstAccessiblePath(permissions) ?? '/'} replace />;
  return <>{children}</>;
};
